import React from 'react';
import { FormattedMessage } from 'react-intl';

const DisconnectCalDialogStrings = {
  title: (
    <FormattedMessage
      id="calendar.connect_cta.dialog.title"
      defaultMessage="Are you sure?"
    />
  ),
  description: (
    <FormattedMessage
      id="calendar.connect_cta.dialog.desc"
      defaultMessage="Removing your synced calendar may result in fewer bookings due to inaccurate availability."
    />
  ),
  confirm: (
    <FormattedMessage
      id="calendar.connect_cta.dialog.button_confirm"
      defaultMessage="Yes, disconnect calendar"
    />
  ),
  cancel: (
    <FormattedMessage
      id="calendar.connect_cta.dialog.cancel"
      defaultMessage="Cancel"
    />
  ),
  disconnectError: (
    <FormattedMessage
      id="calendar.connect_cta.toast.error_disconnect"
      defaultMessage="Unable to disconnect calendar. Please try again"
    />
  )
};

export default DisconnectCalDialogStrings;
